import ACCPSupervisorScreen from './ACCPSupervisorScreen.js';

export default ACCPSupervisorScreen;
